import React, { useEffect, useState } from 'react';
import CerebryPetition from './Components/CerebryPetition';
import Header from './Components/Header';
import Axios from 'axios';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import { DEV_URL } from './Components/constants';

function App(props) {
  const [cityList,setcityList]  = useState([]);
  const [selectedCity,setselectedCity] = useState(undefined);
  const [isThisYouModal, setIsThisYouModal ] = useState(false);
  useEffect(() => {
    const api_url = DEV_URL+ 'api/v2/petitions/cities/'
    const selectedCityIndex = Number(window.location.pathname.split('/')[1])-1;
    Axios.get(api_url)
    .then((resp) => {
      setcityList(resp.data)
      if(!!resp.data[selectedCityIndex]) {
        setselectedCity(resp.data[selectedCityIndex]);
      }
    })
    .catch((err) => {
      console.log("err",err)
    })
  },[])
  const selectCity = (city) => {
    setselectedCity(city);
  }
  const handleIsThisYou = val => {
    setIsThisYouModal(val)
  }
  return (
    <div className="App">
      <Router>
        <Header
          cityList={cityList}
          selectedCity ={selectedCity}
          selectCity = {selectCity}
        />
        <Switch>
          <Route  path="/:id">
            <CerebryPetition
              selectedCity ={selectedCity}
              handleIsThisYou={handleIsThisYou}
            />
          </Route>
        </Switch>
        {
          isThisYouModal &&
          <div className={['cerebry__thisyou__modal']}>
            <div className={['cerebry__you__container']}>
              <div className={['cerebry__this__one']}>
                To remove your name from the trending list, please action on parents' request by setting up a Cerebry demo for your Maths teachers. Email petition@cerebry.co to setup a demo for your Maths teachers and learn how easy it is to setup.
              </div>
              <div className={['cerebry__this__two']}>
                Parents will be informed of your action and  of the Petition and updated post the Pilot.
              </div>
              <div onClick={() => {handleIsThisYou(false)}} className={['cerebry__this__btn']}>close</div>
            </div>
          </div>
        }
      </Router>
    </div>
  );
}

export default App;
